import {
	AdminShell,
	DangerousContent,
	MimaTable,
	MimaText,
} from '../../../components';
import { useAdminSingleProductLogic } from './logic';
import styles from '../../../assets/styles/Admin/AdminProducts.module.scss';
import SingleProductImage from './SingleProductImage';
import { useNavigate } from 'react-router-dom';
import constant from '../../../utils/constant';
import { AnimatePresence } from 'framer-motion';
import DeleteProduct from './DeleteProduct';

export const SingleProduct = () => {
	const {
		name,
		description,
		imageUrls,
		type,
		_id,
		variations,
		variationColumns,
		otherDetails,
		otherDetailsColumns,
		openModalHandler,
		closeModal,
		deleteModalOpen,
	} = useAdminSingleProductLogic();
	const navigate = useNavigate();

	return (
		<AdminShell
			pageTitle={'Product Details'}
			actionButton={[
				{
					title: 'Edit',
					onClick: () => {
						navigate(constant.Routes.Admin.EditProduct.replace(':id', _id));
					},
				},
				{
					title: 'Delete Products',
					onClick: () => {
						openModalHandler();
					},
					buttonColor: 'var(--color-error)',
				},
			]}>
			<div className={styles.singleProduct}>
				<div className="center_container">
					<div className={styles.singleProduct__top}>
						<SingleProductImage name={name} imageUrls={imageUrls} />
						<div className={styles.singleProduct__top__details}>
							<MimaText variant="subtitleBold">{name}</MimaText>
							<DangerousContent content={description} />
							<div>Type: {type}</div>
							<div style={{ maxWidth: '100%' }}>
								<MimaText variant="bodyBold" mb={1} mt={2}>
									Variations & Pricing
								</MimaText>
								<MimaTable
									tableData={variations}
									tableColumns={variationColumns}
									searchPlaceholder="Search Orders"
									searchVariant="wide"
									totalItems={variations?.length}
									hidePagination={true}
									hideSearch={true}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="center_container">
					<div className={styles.singleProduct__bottom}>
						<MimaText variant="bodyBold" mb={1} align="center">
							Other Details
						</MimaText>
						<MimaTable
							tableData={otherDetails}
							tableColumns={otherDetailsColumns}
							totalItems={otherDetails?.length}
							hidePagination={true}
							hideSearch={true}
						/>
					</div>
				</div>
			</div>
			{deleteModalOpen && (
				<div className="modal">
					<AnimatePresence>
						{deleteModalOpen && (
							<DeleteProduct closeModal={closeModal} name={name} id={_id} />
						)}
					</AnimatePresence>
				</div>
			)}
		</AdminShell>
	);
};

export default SingleProduct;
